<script setup lang="ts">
import type { CSSProperties } from 'vue'
import type { NuxtError } from '#app'

// https://nuxt.com/docs/getting-started/error-handling#error-page
const props = defineProps<{
  error: NuxtError
}>()

const handleError = () => clearError({ redirect: '/' })
const contStyle: CSSProperties = {
  minHeight: '100vh',
  padding: '20px',
  backgroundImage: 'linear-gradient(180deg, hsl(0, 0%, 99%) 0%, hsla(220, 70%, 30%, 0.5) 100%)',
  fontSize: '18px',
  letterSpacing: '-0.2px',
  fontWeight: '500',
}

const styleHr: CSSProperties = {
  background: 'hsl(240deg 6% 85%)',
  height: '1px',
  display: 'block',
  border: '0',
  margin: '40px 0',
}
const button: CSSProperties = {
  height: '50px',
  background: 'hsl(240, 100%, 34%)',
  borderRadius: '99px',
  textAlign: 'center',
  fontWeight: '500',
  fontSize: '14px',
  width: '300px',
  color: '#fff',
  maxWidth: '100%',
  border: 'none',
}

const styleA = {
  textDecoration: 'underline',
  color: 'hsl(240, 100%, 34%);',
  fontWeight: '500',
}

const code = {
  fontWeight: '900',
  fontSize: '80px',
  color: '#fff',
}
</script>

<!-- eslint-disable @stylistic/max-len -->

<template>
  <div :style="contStyle" class="_col _gap2">
    <div>
      <svg width="109" height="56" viewBox="0 0 109 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M33.0985 0.511688L27.0553 0.352692L0.019928 27.5471L3.23642 30.8509L33.0985 0.511688ZM45.5089 0.466888L39.2463 0.580887L6.25922 33.778L9.38812 36.959L45.5089 0.466888ZM57.5331 0.513687L51.4591 0.518692L12.4473 39.9801L15.4233 43.008L57.5331 0.513687ZM69.8242 0.530991L63.6863 0.541687L18.4822 46.2323L21.5076 49.3149L69.8242 0.530991ZM81.9426 0.542587L75.8396 0.55899L24.6138 52.3316L27.6619 55.3629L81.9426 0.542587ZM55.8873 29.4877L58.9383 26.451L84.4855 52.1861L81.4533 55.3094L55.8873 29.4877ZM61.9739 23.309L65.0245 20.272L90.5721 46.0072L87.5396 49.1304L61.9739 23.309ZM68.0862 17.225L71.1372 14.1883L96.6844 39.9232L93.6522 43.0464L68.0862 17.225ZM74.1904 11.109L77.2413 8.07199L102.789 33.8072L99.7563 36.9304L74.1904 11.109ZM80.3109 4.96149L83.3619 1.92448L108.909 27.6597L105.877 30.7829L80.3109 4.96149Z" fill="#002855" />
      </svg>
    </div>
    <h1>Sorry</h1>
    <p :style="code">{{ props.error.statusCode }}</p>
    <p>{{ props.error.message }}</p>
    <p>The page you are trying to access does not exist</p>
    <p>This might be because you have entered the web address incorrectly or the page has moved.</p>
    <p>We apologise for any inconvenience.</p>
    <p>For help please visit <a href="https://linas.lt/" :style="styleA" target="_blank">linas.lt</a>.</p>
    <button :style="button" type="button" @click="handleError">Return to home</button>
    <hr :style="styleHr">
    <h1>Atsiprašom</h1>
    <p :style="code">{{ props.error.statusCode }}</p>
    <!-- <p>{{ props.error.message }}</p> -->
    <p>Puslapis, kurį bandote pasiekti, neegzistuoja.</p>
    <p>Tai gali būti dėl to, kad neteisingai įvedėte interneto adresą arba puslapis buvo perkeltas.</p>
    <p>Atsiprašome už nepatogumus.</p>
    <p>Pagalbos kreipkitės į <a href="https://linas.lt/" :style="styleA" target="_blank">linas.lt</a>.</p>
    <button :style="button" type="button" @click="handleError">Grįžti į pradžią</button>
    <hr :style="styleHr">
    <code>{{ props.error }}</code>
  </div>
</template>
